import { LOCAL_STORAGE } from '@/constants';

export type DateDisplayFormat = 'medium' | 'mediumDate' | 'historyDateTime';

export type DateDisplayValue = string | number | Date | null | undefined;

const FORMAT_OPTIONS: Record<DateDisplayFormat, Intl.DateTimeFormatOptions> = {
    mediumDate: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    },
    medium: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    },
    historyDateTime: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    },
};

export const resolveFormattingLocale = (locale?: string): string => {
    if (locale) {
        return locale.replace(/_/g, '-');
    }

    const stored = localStorage.getItem(LOCAL_STORAGE.LANGUAGE_KEY);
    if (stored) {
        return stored.replace(/_/g, '-');
    }

    const htmlLang = document.documentElement.getAttribute('lang');
    if (htmlLang) {
        return htmlLang.replace(/_/g, '-').slice(0, 2);
    }

    return 'en';
};

const toDate = (value: DateDisplayValue): Date | null => {
    if (value == null || value === '') {
        return null;
    }

    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (
    value: DateDisplayValue,
    format: DateDisplayFormat = 'medium',
    locale?: string,
): string => {
    const date = toDate(value);
    const options = FORMAT_OPTIONS[format];
    if (!date || !options) {
        return '';
    }

    return new Intl.DateTimeFormat(resolveFormattingLocale(locale), options).format(date);
};
